import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/defend/StandardDelivers/StandardDelivers.tsx");
